import Accordeon from './accordeon'
import BaseComponent from '../base-component/base-component'
import { checkEnterKey } from '../../utils/utils'

class AccordeonBtn extends BaseComponent {
  connectedCallback(): void {
    this.addEventListener('click', this.handleButtonClick)
    this.addEventListener('keydown', this.handleKeyDown)
  }

  disconnectedCallback(): void {
    this.removeEventListener('click', this.handleButtonClick)
    this.removeEventListener('keydown', this.handleKeyDown)
  }

  handleButtonClick = (event: MouseEvent): void => {
    event.preventDefault()

    this.update()
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    event.preventDefault()

    const isEnterKey = checkEnterKey(event.key || event.keyCode)

    if (isEnterKey) {
      this.update()
    }
  }

  update(): void {
    const accordeon = this.closest<Accordeon>('accordeon-component')

    if (accordeon) {
      accordeon.toggle()
    }
  }
}

export default AccordeonBtn
